import { SVGProps } from "react"

const ListSuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M8.33398 4.16797H18.334"
      stroke="#565868"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33398 10H18.334"
      stroke="#565868"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33398 15.832H18.334"
      stroke="#565868"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.33268 11.6654C3.77471 11.6654 4.19863 11.4898 4.51119 11.1772C4.82375 10.8646 4.99935 10.4407 4.99935 9.9987C4.99935 9.55667 4.82375 9.13275 4.51119 8.82019C4.19863 8.50763 3.77471 8.33203 3.33268 8.33203C2.89065 8.33203 2.46673 8.50763 2.15417 8.82019C1.84161 9.13275 1.66602 9.55667 1.66602 9.9987C1.66602 10.4407 1.84161 10.8646 2.15417 11.1772C2.46673 11.4898 2.89065 11.6654 3.33268 11.6654V11.6654Z"
      stroke="#565868"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.33268 17.5013C3.77471 17.5013 4.19863 17.3257 4.51119 17.0131C4.82375 16.7006 4.99935 16.2767 4.99935 15.8346C4.99935 15.3926 4.82375 14.9687 4.51119 14.6561C4.19863 14.3436 3.77471 14.168 3.33268 14.168C2.89065 14.168 2.46673 14.3436 2.15417 14.6561C1.84161 14.9687 1.66602 15.3926 1.66602 15.8346C1.66602 16.2767 1.84161 16.7006 2.15417 17.0131C2.46673 17.3257 2.89065 17.5013 3.33268 17.5013V17.5013Z"
      stroke="#565868"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.66602 4.16797L2.91602 5.41797L5.41602 2.91797"
      stroke="#565868"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
export default ListSuccessIcon
